import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { BasePolicy } from "../policy/BasePolicy";

export const SurveillancePolicy = BasePolicy;

export type SurveillancePolicy = TypeBoxToType<typeof SurveillancePolicy>;
export type SurveillancePolicyCondition = SurveillancePolicy["conditions"][number];

export const SurveillanceSettings = Type.Object({
  policies: Type.Array(SurveillancePolicy),
  internalPhones: Type.Optional(Type.Array(Type.String())),
});
export type SurveillanceSettings = TypeBoxToType<typeof SurveillanceSettings>;

const LAST_SURVEILLANCE_UPDATE_CACHE_KEY = "surveillance:policies:update";
export const getLastSurveillanceUpdateCacheKey = (orgId: string) => {
  return `${LAST_SURVEILLANCE_UPDATE_CACHE_KEY}:${orgId}`;
};
